import { isMobile } from '../../helpers/isMobile';
import { containerNames } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import { slotBarSymbolEnums } from '../../core/pixi/resources';
import { pixiResourceHelper } from '../../helpers/pixiResourceHelper';
import { gameMainDrawer } from './gameMainDrawer';

export class SlotBarDrawer {
  constructor() {
    this.reels = [];
    this.animations = {};
    this.slotBarItemsByIdTexture = {};
    this.SlotBarContainer = PixiBase.createContainer(containerNames.SlotBarContainer);
    this.mask = null;
  }

  setupSlotBarReelsContainer() {
    this.slotBarReelsContainer = PixiBase.createContainer(containerNames.SlotBarReelsContainer);
    this.WinBarContainer = PixiBase.createContainer(containerNames.WinBarContainer);
    gameMainDrawer.slotBoard.slotBoard.addChildToSlot('board', this.slotBarReelsContainer);
    // gameMainDrawer.slotBoard.slotBoard.play('dropBoard', true);
    const { slotBarReelsContainerConfig, slotBarReelContainer } = this.config.SlotBarContainer;
    const { x, y } = slotBarReelContainer;
    PixiBase.setPosition(this.slotBarReelsContainer, { x: x, y: y });
    // this.slotBarReelsContainer.x = -636.5;
    // this.slotBarReelsContainer.y = -168;
    const { x: reelX, y: reelY } = slotBarReelsContainerConfig;
    // PixiBase.setPosition(this.slotBarReelsContainer, { x: reelX, y: reelY });
    PixiBase.setPosition(this.WinBarContainer, { x: reelX, y: reelY });
    // Masking slot reels
    if (isMobile()) {
      const slotBarMasGraphics = PixiBase.createGraphics();
      this.mask = PixiBase.setMaskGraphicProperties(slotBarMasGraphics, [9, 257, 524, 295]);
    } else {
      this.mask = PixiBase.createSprite(this.spriteSheet.mask);
      this.mask.x = 165;
      this.mask.y = 128;
    }
    this.columnsMaskGraphics = this.mask;
    this.slotBarReelsContainer = PixiBase.setMaskGraphicToContainer(
      this.slotBarReelsContainer,
      this.mask
    );

    // Setup slotBar symbols
    Object.keys(slotBarSymbolEnums).forEach((key) => {
      this.slotBarItemsByIdTexture = {
        ...this.slotBarItemsByIdTexture,
        [key]: pixiResourceHelper.get(slotBarSymbolEnums[key]),
      };
    });
    // this.SlotBarContainer.addChild(this.slotBarReelsContainer);
    this.SlotBarContainer.addChild(this.WinBarContainer);
    this.SlotBarContainer.addChild(this.mask);
  }

  addOnDownHandler(callback) {
    PixiBase.registerClick(this.slotBarReelsContainer, callback);
  }

  addOnUpHandler(callback) {
    PixiBase.registerPointerup(this.slotBarReelsContainer, callback);
  }

  addOnMoveHandler(callback) {
    PixiBase.registerPointerMove(this.slotBarReelsContainer, callback);
  }

  addOnOutHandler(callback) {
    PixiBase.registerPointerout(this.slotBarReelsContainer, callback);
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.setupSlotBarReelsContainer();
  }
}
